module.exports = __webpack_public_path__ + "img/hohlschnitt_tiefschwarz_ral9005.c74ff9f1.jpg";